export default __webpack_public_path__ + "static/media/invitesHeader.ffae3db3.png";